//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageFooterKol.vue